(function(){
  function init(root){
    if(root.__imInit){ return; } root.__imInit = true;
    var hotspots = root.querySelectorAll('.im-hotspot');
    var backdrop = root.querySelector('.im-backdrop');
    function closeAll(){
      var open = root.querySelectorAll('.im-popup.is-open');
      for(var i=0;i<open.length;i++){ open[i].classList.remove('is-open'); }
      root.classList.remove('im-modal-open');
    }
    for(var h=0;h<hotspots.length;h++){
      (function(hs){
        var marker = hs.querySelector('.im-marker');
        var popup = hs.querySelector('.im-popup');
        if(!marker || !popup){ return; }
        var closeBtn = popup.querySelector('.im-popup-close');
        marker.addEventListener('click', function(e){
          e.stopPropagation();
          var isOpen = popup.classList.contains('is-open');
          closeAll();
          if(!isOpen){ popup.classList.add('is-open'); root.classList.add('im-modal-open'); }
        });
        marker.addEventListener('keydown', function(e){ if(e.key==='Enter' || e.key===' '){ e.preventDefault(); marker.click(); } });
        if(closeBtn){ closeBtn.addEventListener('click', function(e){ e.stopPropagation(); closeAll(); }); }
      })(hotspots[h]);
    }
    if(backdrop){ backdrop.addEventListener('click', closeAll); }
    document.addEventListener('click', function(e){
      if(!e.target || !e.target.closest){ return; }
      if(!e.target.closest('.im-hotspot') && !e.target.closest('.im-popup')){ closeAll(); }
    });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape'){ closeAll(); } });
  }
  function boot(){ var maps=document.querySelectorAll('.im-map'); for(var i=0;i<maps.length;i++){ init(maps[i]); } }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();
